import getApiClient from '@/plugins/api-client'

export default {
  loadSubscription () {
    const api = getApiClient(this.$store)
    const subscriptionId = this.$route.params.id

    api.get(`subscriptions/${subscriptionId}`)
      .then(result => {
        this.subscription = result.data
      })
      .catch(error => {
        this.error = error
      })
  },
}
